import { render, staticRenderFns } from "./ChartOrkPlans.vue?vue&type=template&id=2a0c8336&scoped=true"
import script from "./ChartOrkPlans.vue?vue&type=script&lang=js"
export * from "./ChartOrkPlans.vue?vue&type=script&lang=js"
import style0 from "./ChartOrkPlans.vue?vue&type=style&index=0&id=2a0c8336&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0c8336",
  null
  
)

export default component.exports